// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { LoginSiderText } from '@Organisms/Login/LoginSiderText/LoginSiderText';
import { getAvatarUrl } from '@Helpers/';

import './LoginSider.scss';

export const LoginSider = ({ src }: { src?: string }): ReactElement => (
    <div className="login-sider">
        <div className="login-sider__background-image">
            <img className="login-sider__background-image__bg" src={'static/images/login-background.png'} />
        </div>
        <div className="login-sider__background-gradient" />
        <div className="login-sider__content">
            <div className="login-sider__content-logo">
                <img alt="logo-thehive" src={src ? getAvatarUrl(src) : 'static/login-logo-thehive.svg'} />
            </div>
            <div className="login-sider__content-footer">
                <LoginSiderText />
            </div>
        </div>
    </div>
);
